var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTkn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#24DD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36425 4.45106L9.84094 3.375L9.82069 6.21731H12.9375V8.18606H9.79988V11.5965C9.79988 12.6315 11.5549 12.7536 12.2153 12.4087L12.8138 14.1952C11.3479 15.0474 7.34344 14.8444 7.34344 11.6168V4.4505L7.36425 4.45106ZM5.05238 8.71369C4.43644 8.71369 3.9375 8.11406 3.9375 7.37437C3.9375 6.63412 4.43644 6.0345 5.05238 6.0345C5.66775 6.0345 6.16669 6.63412 6.16669 7.37437C6.16669 8.11406 5.66775 8.71369 5.05238 8.71369Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTkn);
export default __webpack_public_path__ + "static/media/tkn.282c9a0d82ebb9573ffe626154a738b1.svg";
export { ForwardRef as ReactComponent };